import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MenuByUserState } from './menu-by-user.model';

export const selectMenuByUserState = createFeatureSelector<MenuByUserState>('menuByUser');

export const selectMenuByUserData = createSelector(selectMenuByUserState, (state) => state.data);

export const selectMenuByUserLoading = createSelector(selectMenuByUserState, (state) => state.loading);

export const selectMenuByUserError = createSelector(selectMenuByUserState, (state) => state.error);
